import React from 'react'
import css from './style.scss'

export default (props)=>(
  <div className={props.white ? css.pinkBackground : css.pinkBackground}>
    <Page>
      {props.children}
    </Page>
  </div>
)

export const Page=(props)=>(
  <div className={css.page}>{props.children}</div>
)



// WEBPACK FOOTER //
// ./src/components/home_page/landing/sections/background.js